


































































































import {Vue, Component} from 'vue-property-decorator';
import {GetProductBulkImagesRequest, GetProductBulkImagexExcelRequest} from 'supporter';
import PageTitle from '@/components/common/PageTitle.vue';
import ItemTable from '@/components/common/ItemTable.vue';
import {getToday} from '@/utils/dateUtils';
import {saveAs} from 'file-saver';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import CompCheckBox from '@/components/common/CompCheckBoxButton.vue';
import PeriodDateCalendar from '@/components/common/datepicker/PeriodDateCalendar.vue';
import imageUploadTypes from '@/const/words/imageUploadTypes';
import imageUploadProgressTypes from '@/const/words/imageUploadProgressTypes';
import imageUploadKeywordTypes from '@/const/words/imageUploadKeywordTypes';

@Component({
  components: {
    PageTitle,
    ItemTable,
    CompSelectBox,
    PeriodDateCalendar,
    CompCheckBox
  }
})
export default class ProductBulkImageList extends Vue {
  private searchKeyword: string = '';
  private isSearchKeyword: boolean = false;
  private totalCount: number = 0;
  private bulkImageList = [];
  private page: number = 1;
  private pageSize: number = 100;
  private getProductBulkImages: GetProductBulkImagesRequest = {
    params: {
      uploadType: null,
      'keywordInfo.type': '',
      'keywordInfo.keywords': '',
      'periodInfo.type': '',
      'periodInfo.period.startDate': '',
      'periodInfo.period.endDate': '',
      progressTypes: '',
      page: this.page,
      size: this.pageSize
    }
  };

  private getProductBulkImageExcel: GetProductBulkImagexExcelRequest = {
    params: {
      no: '' as string
    }
  };

  // 이미지 업로드 방법
  private imageUploadType = this.getImageUploadTypes(this.$t('PRODUCT_BULK_IMAGE_ALL') as string, 1);
  private imageUploadTypes = [
    {
      value: this.getImageUploadTypes(this.$t('PRODUCT_BULK_IMAGE_ALL') as string, 1),
      name: this.getImageUploadTypes(this.$t('PRODUCT_BULK_IMAGE_ALL') as string, 0)
    },
    {
      value: this.getImageUploadTypes(this.$t('PRODUCT_BULK_IMAGE_SETTING_UPLOAD_ITEM') as string, 1),
      name: this.getImageUploadTypes(this.$t('PRODUCT_BULK_IMAGE_SETTING_UPLOAD_ITEM') as string, 0)
    },
    {
      value: this.getImageUploadTypes(this.$t('PRODUCT_BULK_IMAGE_SETTING_UPLOAD_ITEM_3') as string, 1),
      name: this.getImageUploadTypes(this.$t('PRODUCT_BULK_IMAGE_SETTING_UPLOAD_ITEM_3') as string, 0)
    }
  ];

  private getImageUploadTypes(value: string, type: number) {
    const findImageUploadType = imageUploadTypes.find((item: any) => item.name === value);
    switch (type) {
      case 0:
        if (findImageUploadType) {
          return findImageUploadType.name;
        }
      case 1:
        if (findImageUploadType) {
          return findImageUploadType.value;
        }
    }
  }

  // 검색어
  private keywordSearchType = this.getImageUploadKeywordTypes(this.$t('PRODUCT_BULK_IMAGE_SEARCH_WORD_TYPE1') as string, 1);
  private keywordSearchTypes = [
    {
      value: this.getImageUploadKeywordTypes(this.$t('PRODUCT_BULK_IMAGE_SEARCH_WORD_TYPE1') as string, 1),
      name: this.getImageUploadKeywordTypes(this.$t('PRODUCT_BULK_IMAGE_SEARCH_WORD_TYPE1') as string, 0)
    },
    {
      value: this.getImageUploadKeywordTypes(this.$t('PRODUCT_BULK_IMAGE_SEARCH_WORD_TYPE2') as string, 1),
      name: this.getImageUploadKeywordTypes(this.$t('PRODUCT_BULK_IMAGE_SEARCH_WORD_TYPE2') as string, 0)
    },
    {
      value: this.getImageUploadKeywordTypes(this.$t('PRODUCT_BULK_IMAGE_SEARCH_WORD_TYPE3') as string, 1),
      name: this.getImageUploadKeywordTypes(this.$t('PRODUCT_BULK_IMAGE_SEARCH_WORD_TYPE3') as string, 0)
    }
  ];

  private getImageUploadKeywordTypes(value: string, type: number) {
    const findImageUploadKeywordType = imageUploadKeywordTypes.find((item: any) => item.name === value);
    switch (type) {
      case 0:
        if (findImageUploadKeywordType) {
          return findImageUploadKeywordType.name;
        }
      case 1:
        if (findImageUploadKeywordType) {
          return findImageUploadKeywordType.value;
        }
    }
  }

  private startDate: string = getToday();
  private endDate: string = getToday();
  private periodOption = {
    name: 'periodOption',
    period: 'td',
    periodTypes: ['td', '1w', '1m', '3m', '6m', '1y']
  };

  private imageRegisterProgressType: string = this.getImageUploadProgressTypes(this.$t('PRODUCT_BULK_IMAGE_SEARCH_PROGRESS_TYPE_ALL') as string, 1);
  private imageRegisterProgressTypesCheckboxOptions = {
    name: 'imageRegisterProgressTypes',
    hasAll: true,
    noBrackets: true,
    data: [
      {
        id: 'ALL',
        value: this.getImageUploadProgressTypes(this.$t('PRODUCT_BULK_IMAGE_SEARCH_PROGRESS_TYPE_ALL') as string, 1),
        dispaly: this.getImageUploadProgressTypes(this.$t('PRODUCT_BULK_IMAGE_SEARCH_PROGRESS_TYPE_ALL') as string, 0)
      },
      {
        id: this.getImageUploadProgressTypes(this.$t('PRODUCT_BULK_IMAGE_SEARCH_PROGRESS_TYPE_READY') as string, 1),
        value: this.getImageUploadProgressTypes(this.$t('PRODUCT_BULK_IMAGE_SEARCH_PROGRESS_TYPE_READY') as string, 1),
        dispaly: this.getImageUploadProgressTypes(this.$t('PRODUCT_BULK_IMAGE_SEARCH_PROGRESS_TYPE_READY') as string, 0)
      },
      {
        id: this.getImageUploadProgressTypes(this.$t('PRODUCT_BULK_IMAGE_SEARCH_PROGRESS_TYPE_PROGRESS') as string, 1),
        value: this.getImageUploadProgressTypes(this.$t('PRODUCT_BULK_IMAGE_SEARCH_PROGRESS_TYPE_PROGRESS') as string, 1),
        dispaly: this.getImageUploadProgressTypes(this.$t('PRODUCT_BULK_IMAGE_SEARCH_PROGRESS_TYPE_PROGRESS') as string, 0)
      },
      {
        id: this.getImageUploadProgressTypes(this.$t('PRODUCT_BULK_IMAGE_SEARCH_PROGRESS_TYPE_FINISHED') as string, 1),
        value: this.getImageUploadProgressTypes(this.$t('PRODUCT_BULK_IMAGE_SEARCH_PROGRESS_TYPE_FINISHED') as string, 1),
        dispaly: this.getImageUploadProgressTypes(this.$t('PRODUCT_BULK_IMAGE_SEARCH_PROGRESS_TYPE_FINISHED') as string, 0)
      }
    ]
  };

  private getImageUploadProgressTypes(value: string, type: number) {
    const findImageUploadProgressType = imageUploadProgressTypes.find((item: any) => item.name === value);
    switch (type) {
      case 0:
        if (findImageUploadProgressType) {
          return findImageUploadProgressType.name;
        }
      case 1:
        if (findImageUploadProgressType) {
          return findImageUploadProgressType.value;
        }
    }
  }

  private setImageUploadProgressTypes() {
    if (this.imageRegisterProgressType === 'ALL') {
      this.imageRegisterProgressType = this.getImageUploadProgressTypes(this.$t('PRODUCT_BULK_IMAGE_SEARCH_PROGRESS_TYPE_ALL') as string, 1);
    } else {
      this.imageRegisterProgressType;
    }
  }

  private tableOption = {
    name: 'imageRegisterStatusGrid',
    haveExcelDownBtn: false,
    onLoadSearch: false,
    pageSize: '100',
    pageSizes: [
      {
        value: '100',
        name: 'COMMON_PAGE_SIZE_100'
      },
      {
        value: '200',
        name: 'COMMON_PAGE_SIZE_200'
      },
      {
        value: '500',
        name: 'COMMON_PAGE_SIZE_500'
      },
      {
        value: '1000',
        name: 'COMMON_PAGE_SIZE_1000'
      }
    ]
  };

  private gridProps = {
    columns: [
      {
        header: this.$t('PRODUCT_BULK_IMAGE_SETTING_UPLOAD'),
        name: 'uploadType',
        align: 'center',
        formatter: (cell: any) => {
          switch (cell.value) {
            case this.getImageUploadTypes(this.$t('PRODUCT_BULK_IMAGE_SETTING_UPLOAD_ITEM') as string, 1):
              return this.getImageUploadTypes(this.$t('PRODUCT_BULK_IMAGE_SETTING_UPLOAD_ITEM') as string, 0);
            case this.getImageUploadTypes(this.$t('PRODUCT_BULK_IMAGE_SETTING_UPLOAD_ITEM_3') as string, 1):
              return this.getImageUploadTypes(this.$t('PRODUCT_BULK_IMAGE_SETTING_UPLOAD_ITEM_3') as string, 0);
          }
        },
        copyOptions: {
          useFormattedValue: true
        },
      },
      {
        header: this.$t('PRODUCT_BULK_IMAGE_SETTING_FILENAME'),
        name: 'namingType',
        align: 'center',
        formatter: (cell: any) => {
          switch (cell.value) {
            case this.getImageUploadKeywordTypes(this.$t('PRODUCT_BULK_IMAGE_SEARCH_WORD_TYPE1') as string, 1):
              return this.getImageUploadKeywordTypes(this.$t('PRODUCT_BULK_IMAGE_SEARCH_WORD_TYPE1') as string, 0);
            case this.getImageUploadKeywordTypes(this.$t('PRODUCT_BULK_IMAGE_SEARCH_WORD_TYPE2') as string, 1):
              return this.getImageUploadKeywordTypes(this.$t('PRODUCT_BULK_IMAGE_SEARCH_WORD_TYPE2') as string, 0);
            case this.getImageUploadKeywordTypes(this.$t('PRODUCT_BULK_IMAGE_SEARCH_WORD_TYPE3') as string, 1):
              return this.getImageUploadKeywordTypes(this.$t('PRODUCT_BULK_IMAGE_SEARCH_WORD_TYPE3') as string, 0);
          }
        },
        copyOptions: {
          useFormattedValue: true
        },
      },
      {
        header: this.$t('PRODUCT_BULK_IMAGE_SEARCH_PROGRESS'),
        name: 'progressType',
        align: 'center',
        formatter: (cell: any) => {
          switch (cell.value) {
            case this.getImageUploadProgressTypes(this.$t('PRODUCT_BULK_IMAGE_SEARCH_PROGRESS_TYPE_READY') as string, 1):
              return this.getImageUploadProgressTypes(this.$t('PRODUCT_BULK_IMAGE_SEARCH_PROGRESS_TYPE_READY') as string, 0);
            case this.getImageUploadProgressTypes(this.$t('PRODUCT_BULK_IMAGE_SEARCH_PROGRESS_TYPE_PROGRESS') as string, 1):
              return this.getImageUploadProgressTypes(this.$t('PRODUCT_BULK_IMAGE_SEARCH_PROGRESS_TYPE_PROGRESS') as string, 0);
            case this.getImageUploadProgressTypes(this.$t('PRODUCT_BULK_IMAGE_SEARCH_PROGRESS_TYPE_FINISHED') as string, 1):
              return this.getImageUploadProgressTypes(this.$t('PRODUCT_BULK_IMAGE_SEARCH_PROGRESS_TYPE_FINISHED') as string, 0);
          }
          return cell.value;
        },
        copyOptions: {
          useFormattedValue: true
        },
      },
      {
        header: this.$t('PRODUCT_BULK_IMAGE_SEARCH_PERIOD_TYPE'),
        name: 'registerDateTime',
        align: 'center'
      },
      {
        header: this.$t('PRODUCT_BULK_IMAGE_ADMIN_NAME'),
        name: 'registerName',
        align: 'center'
      },
      {
        header: this.$t('PRODUCT_BULK_IMAGE_DETAIL'),
        name: 'detail',
        align: 'center',
        formatter: (cell: any) => {
          return `<a class="downloadExcel" style="cursor:pointer" data-upload-no="${cell.row.no}">${this.$t('PRODUCT_BULK_IMAGE_EXCEL_DOWNLOAD')}</a>`;
        }
      }
    ],
    header: {
      height: 32
    },
    options: {
      rowHeaders: ['rowNum'],
      minRowHeight: 31,
      rowHeight: 31,
      bodyHeight: 500,
      isInitialRequest: false,
      useClientSort: false,
      pageOptions: {
        perPage: this.getProductBulkImages.params.size,
        page: this.getProductBulkImages.params.page,
        totalCount: 0,
        visiblePages: 5
      }
    }
  };

  private onPageSizeChange(page: number, pageSize: number) {
    this.page = page;
    if (pageSize) {
      this.pageSize = pageSize;
    }
    this.searchBulkImageList(page);
  }

  private init() {
    this.getProductBulkImages = {
      params: {
        uploadType: this.imageUploadType as string,
        'keywordInfo.type': this.keywordSearchType as string,
        'keywordInfo.keywords': '',
        'periodInfo.type': 'REGISTER_DATE',
        'periodInfo.period.startDate': this.startDate as string,
        'periodInfo.period.endDate': this.endDate as string,
        progressTypes: this.getImageUploadProgressTypes(this.$t('PRODUCT_BULK_IMAGE_SEARCH_PROGRESS_TYPE_ALL') as string, 1),
        page: 1,
        size: 100
      }
    };
  }

  private created() {
    $('body').on('click', '.downloadExcel', $.proxy(this.downLoadImageExcelFile, this));
    this.init();
    this.searchBulkImageList(1);
  }

  private destroyed() {
    $('body').off('click', '.downloadExcel', $.proxy(this.downLoadImageExcelFile, this));
  }

  private setSearchFormData(page): void {
    let params = {
      uploadType: this.imageUploadType as string,
      'keywordInfo.type': this.keywordSearchType as string,
      'keywordInfo.keywords': this.searchKeyword.replace(/(?:\\[rn]|[\r\n]+)+/g, ','),
      'periodInfo.type': 'REGISTER_DATE',
      'periodInfo.period.startDate': this.startDate as string,
      'periodInfo.period.endDate': this.endDate as string,
      progressTypes: this.imageRegisterProgressType,
      page: page,
      size: this.pageSize
    };
    this.getProductBulkImages = {
      params: params
    };
  }

  private async searchBulkImageList(page) {
    this.isInavilidKeyword();
    if (this.isSearchKeyword) {
      this.setSearchFormData(page);
      const getProductBulkImagesResponse = await this.$api.getProductBulkImages(this.getProductBulkImages);
      const {data} = getProductBulkImagesResponse;
      this.setGridData(data, page);
    }
  }

  private isInavilidKeyword() {
    if (this.searchKeyword != '' && this.keywordSearchType == this.getImageUploadKeywordTypes(this.$t('PRODUCT_BULK_IMAGE_SEARCH_WORD_TYPE1') as string, 1)) {
      let keywords = this.searchKeyword
        .replace(/\r\n|\n/g, ',')
        .split(',')
        .filter((v) => v.length > 0);
      keywords = keywords.map((el) => el.trim());
      let regExp = /^\d+$/;
      let isAllNumber = true;
      keywords.some((v) => {
        isAllNumber = regExp.test(v);
        return isAllNumber === false;
      });
      return isAllNumber ? (this.isSearchKeyword = true) : (this.isSearchKeyword = false);
    } else {
      return (this.isSearchKeyword = true);
    }
  }

  private resetBulkImageList(): void {
    this.imageUploadType = this.getImageUploadTypes(this.$t('PRODUCT_BULK_IMAGE_ALL') as string, 1);
    this.keywordSearchType = this.getImageUploadKeywordTypes(this.$t('PRODUCT_BULK_IMAGE_SEARCH_WORD_TYPE1') as string, 1);
    this.searchKeyword = '';
    let tempVue: any = this.$refs.datePicker;
    tempVue.clickPeriod('td');
    this.imageRegisterProgressType = this.getImageUploadProgressTypes(this.$t('PRODUCT_BULK_IMAGE_SEARCH_PROGRESS_TYPE_ALL') as string, 1);
    if (!$('#imageRegisterProgressTypes_ALL').prop('checked')) {
      $('#imageRegisterProgressTypes_ALL').click();
    }
    this.setImageUploadProgressTypes();
    this.getProductBulkImages = {
      params: {
        uploadType: null,
        'keywordInfo.type': this.keywordSearchType as string,
        'keywordInfo.keywords': this.searchKeyword,
        'periodInfo.type': 'REGISTER_DATE',
        'periodInfo.period.startDate': this.startDate as string,
        'periodInfo.period.endDate': this.endDate as string,
        progressTypes: this.getImageUploadProgressTypes(this.$t('PRODUCT_BULK_IMAGE_SEARCH_PROGRESS_TYPE_ALL') as string, 1),
        page: 1,
        size: 100
      }
    };
  }

  private setGridData(data: any, page: any) {
    this.bulkImageList = data.contents;
    this.gridProps.options.pageOptions.page = page;
    this.gridProps.options.pageOptions.perPage = this.pageSize;
    this.gridProps.options.pageOptions.totalCount = data.totalCount;
    this.totalCount = data.totalCount;
  }

  private downLoadImageExcelFile(e: any): void {
    let downloadNo = $(e.target).data('upload-no');
    this.getProductBulkImageExcel.params.no = downloadNo;
    this.getBulkImageExcel();
  }

  private getBulkImageExcel() {
    this.$api.getProductBulkImagesExcel(this.getProductBulkImageExcel).then((res) => {
      const fileName = 'image_upload_result_' + getToday() + '.xlsx';
      const blob = new window.Blob([res.data], {type: 'blob'});
      saveAs(blob, fileName);
    });
  }
}
